export enum ProcessStatus {
  UNPAID = 'UNPAID',
  PAID_LAND = 'PAID_LAND',
  PAID_HOME = 'PAID_HOME',
  PAID_LAND_AND_HOME = 'PAID_LAND_AND_HOME',
  OVERRIDE = 'OVERRIDE',
}
